import moment from 'moment-timezone'
import { findIana } from 'windows-iana'
import { isString } from 'lodash'
import { errorCodes, getUserFriendlyErrorMessage } from './errormessages'
import { isEllipsisActive } from './commonMembersPage'
import {
  DATE_FORMAT_TYPE_DATE,
  DATE_FORMAT_TYPE_TIME,
  ABBREVIATION_TO_DAY_OF_WEEK,
  STATUS_CANCEL_DENIED_TEXT,
  STATUS_CANCEL_PENDING_TEXT,
  STATUS_CANCELED_TEXT,
  STATUS_PENDING_TEXT,
  STATUS_PRINTED_TEXT,
  STATUS_VALUES_MAP,
  STATUS_XMIT_FAILED_TEXT,
  STATUS_XMIT_TEXT,
  DRUG_SCREEN_STATUS,
} from './constants'
import { getFreeDrugRuleLayout } from '../pages/patient-chart-page/components/files-section/helper'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
function minutesAfterMidnightToTime(minutesAfterMidnight) {
  const hours = Math.floor(minutesAfterMidnight / 60) % 12 || 12 // 12-hour clock
  const minutes = minutesAfterMidnight % 60
  const period = minutesAfterMidnight < 720 ? 'am' : 'pm' // determine AM or PM
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}${period}`
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
function timeToMinutesAfterMidnight(time) {
  const [hours, minutes] = time.match(/\d+/g).map(Number)
  const isPM = /pm/i.test(time)
  if (isPM && hours === 12) {
    return ((hours % 12) + (isPM && hours !== 12 ? 12 : 0)) * 60 + minutes + 720
  }
  return ((hours % 12) + (isPM && hours !== 12 ? 12 : 0)) * 60 + minutes
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getOnlyFutureAvailableTimes = (arr, date, timeZone) => {
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const minutesAfterMidnightArray = arr.map((time) => timeToMinutesAfterMidnight(time))
  const timeDate = date.tz(timeZone, true)
  const nowDateInMinutes = timeToMinutesAfterMidnight(moment(timeDate).format('hh:mma'))
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const filteredByNowDate = minutesAfterMidnightArray.filter((t) => t > nowDateInMinutes)
  const availableTimes = filteredByNowDate.length < 6 ? minutesAfterMidnightArray.slice(-6) : filteredByNowDate

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  return availableTimes.map((minutes) => minutesAfterMidnightToTime(minutes))
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getBodyHeightValue = (heighInchesFromAPI) => {
  if (heighInchesFromAPI) {
    const inchesInOneFeet = 12
    const heightFeetValue = Math.floor(heighInchesFromAPI / inchesInOneFeet)
    const heightInches = heighInchesFromAPI % inchesInOneFeet
    return `${heightFeetValue} ft ${heightInches ? `${heightInches} in` : ''}`
  }

  return null
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function capitalize(s) {
  return s[0].toUpperCase() + s.slice(1)
}

export const severitiesData = {
  severe: {
    priority: 1,
    key: 'severe',
    value: 'Severe: Anaphylaxis, chest tightness, etc',
  },
  moderate: {
    priority: 2,
    key: 'moderate',
    value: 'Moderate: tingling, swelling, rash, etc',
  },
  mild: {
    priority: 3,
    key: 'mild',
    value: 'Mild: sneezing, itching, redness',
  },
}

export const statesOptions = [
  'Alabama AL',
  'Alaska AK',
  'Arizona AZ',
  'Arkansas AR',
  'California CA',
  'Colorado CO',
  'Connecticut CT',
  'Delaware DE',
  'District of Columbia DC',
  'Florida FL',
  'Georgia GA',
  'Hawaii HI',
  'Idaho ID',
  'Illinois IL',
  'Indiana IN',
  'Iowa IA',
  'Kansas KS',
  'Kentucky KY',
  'Louisiana LA',
  'Maine ME',
  'Maryland MD',
  'Massachusetts MA',
  'Michigan MI',
  'Minnesota MN',
  'Mississippi MS',
  'Missouri MO',
  'Montana MT',
  'Nebraska NE',
  'Nevada NV',
  'New Hampshire NH',
  'New Jersey NJ',
  'New Mexico NM',
  'New York NY',
  'North Carolina NC',
  'North Dakota ND',
  'Ohio OH',
  'Oklahoma OK',
  'Oregon OR',
  'Pennsylvania PA',
  'Rhode Island RI',
  'South Carolina SC',
  'South Dakota SD',
  'Tennessee TN',
  'Texas TX',
  'Utah UT',
  'Vermont VT',
  'Virginia VA',
  'Washington WA',
  'West Virginia WV',
  'Wisconsin WI',
  'Wyoming WY',
]

const statesAddressDropdownList = [
  'AK',
  'AL',
  'AR',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
]

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const removeEmojis = (string) => {
  const regex =
    /\uD83C\uDFF4(?:\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74)\uDB40\uDC7F|\u200D\u2620\uFE0F)|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3]))|\uD83D\uDC69\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\uD83D\uDC68(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83D\uDC69\u200D[\u2695\u2696\u2708])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC68(?:\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])|(?:[#*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDD1-\uDDDD])/g

  return string.replace(regex, '')
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getVisitStatus = (status) => {
  switch (status) {
    case 'inwaitingroom':
      return 'In waiting room'
    case 'inwaitingroomback':
      return 'In waiting room'
    case 'inprogress':
      return 'In progress'
    case 'unresolved':
      return 'Unresolved'
    case 'resolved':
      return 'Resolved'
    case 'cancelledbypatient':
      return 'Canceled by patient'
    case 'scheduledbypatient':
      return 'Patient scheduled'
    case 'rescheduledbypatient':
      return 'Patient rescheduled'
    case 'scheduledbyadmin':
      return 'Staff scheduled'
    case 'ended':
      return 'Ended'
    case 'completed':
      return 'Complete'
    case 'cancelledbyadmin':
      return 'Canceled by staff'
    case 'rescheduledbyadmin':
      return 'Staff rescheduled'
    default:
      break
  }
}

export const sortedStatesAddressDropdownList = statesAddressDropdownList.sort((a, b) => {
  // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
  if (a[0] < b[0]) {
    return -1
  }

  // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
  if (a[0] > b[0]) {
    return 1
  }

  if (a[0] === b[0]) {
    // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
    if (a[1] < b[1]) {
      return -1
    }
    // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
    if (a[1] > b[1]) {
      return 1
    }
  }

  return 0
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPharmacyAddressValue = (pharmacy) => {
  if (pharmacy) {
    const { Name } = pharmacy
    const { StreetAddress1, StreetAddress2, City, StateCode, Zip, CountryCode } = pharmacy?.Address || {}

    return `${Name} - ${StreetAddress1}, ${
      StreetAddress2 ? `${StreetAddress2}, ` : ''
    }${City}, ${StateCode} ${Zip}, ${CountryCode}`
  }

  return null
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const modifySelectedPharmacyConfigForUpdate = ({ Address, Name, PharmacyId }) => ({
  Address,
  Name,
  PharmacyId,
  NcpdpId: PharmacyId,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getStateByAbbreviation = (abbr, isWithAbbr?) => {
  if (abbr) {
    if (abbr === 'VI') {
      return isWithAbbr ? 'Virgin Islands VI' : 'Virgins Island'
    }
    if (abbr === 'PR') {
      return isWithAbbr ? 'Puerto Rico PR' : 'Puerto Rico'
    }
    const state = statesOptions.find((t) => t.includes(abbr))
    return isWithAbbr ? state : state?.slice(0, -2)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const validateEmail = (email) =>
  String(email)
    .toLowerCase()
    .match(/^(?!\.)(?!.*\.$)(?!.*\.\.)(?!.*\.@)[a-zA-Z0-9_.+-]+@(?!\.)[a-zA-Z0-9_.+-]+\.[a-zA-Z0-9_.+-]+$/)

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const isDuplicatedLicenses = (licenseArray) => {
  // @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
  let dublicatedIds = []
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const checkArray = licenseArray.map((t) => ({
    id: t.licenseBlockId,
    Number: t.licenseNumberValue?.trim(),
    StateValue: t.stateLicenseValue,
    licensedByValue: t.licensedByValue,
  }))

  for (let i = 0; i < checkArray.length; i++) {
    const tempCheck = [...checkArray]
    const temp = { ...tempCheck[i] }
    let isDublicatedTemp = false
    for (let j = 0; j < tempCheck.length; j++) {
      if (temp.id === tempCheck[j].id) {
        delete tempCheck[j]
      } else if (
        temp?.Number === tempCheck[j]?.Number &&
        temp.Number?.length > 0 &&
        tempCheck[j].Number?.length > 0 &&
        temp?.StateValue === tempCheck[j]?.StateValue &&
        temp.StateValue?.length > 0 &&
        tempCheck[j].StateValue?.length > 0 &&
        temp?.licensedByValue?.trim() === tempCheck[j]?.licensedByValue?.trim() &&
        temp.licensedByValue?.length > 0 &&
        tempCheck[j].licensedByValue?.length > 0
      ) {
        isDublicatedTemp = true
        // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
        dublicatedIds = [...dublicatedIds, tempCheck[j].id]
        delete tempCheck[j]
      }
    }
    if (isDublicatedTemp) {
      // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
      dublicatedIds = [...dublicatedIds, temp.id]
    }
  }

  return !!dublicatedIds.length
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const validateLicenses = (licenseArray, setLicenseArray) => {
  // @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
  let dublicatedIds = []
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const checkArray = licenseArray.map((t) => ({
    id: t.licenseBlockId,
    Number: t.licenseNumberValue?.trim(),
    StateValue: t.stateLicenseValue,
    licensedByValue: t.licensedByValue,
  }))

  for (let i = 0; i < checkArray.length; i++) {
    const tempCheck = [...checkArray]
    const temp = { ...tempCheck[i] }
    let isDublicatedTemp = false
    for (let j = 0; j < tempCheck.length; j++) {
      if (temp.id === tempCheck[j].id) {
        delete tempCheck[j]
      } else if (
        temp.Number === tempCheck[j].Number &&
        temp.Number?.length > 0 &&
        tempCheck[j].Number?.length > 0 &&
        temp.StateValue === tempCheck[j].StateValue &&
        temp.StateValue?.length > 0 &&
        tempCheck[j].StateValue?.length > 0 &&
        temp?.licensedByValue?.trim() === tempCheck[j]?.licensedByValue?.trim() &&
        temp.licensedByValue?.length > 0 &&
        tempCheck[j].licensedByValue?.length > 0
      ) {
        isDublicatedTemp = true
        // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
        dublicatedIds = [...dublicatedIds, tempCheck[j].id]
        delete tempCheck[j]
      }
    }
    if (isDublicatedTemp) {
      // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
      dublicatedIds = [...dublicatedIds, temp.id]
    }
  }
  // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
  const correctDublicatesIdsList = [...new Set(dublicatedIds)]
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const correctLicenseArray = licenseArray.map((t) =>
    correctDublicatesIdsList.some((j) => j === t.licenseBlockId) ?
      {
        ...t,
        licenseNumberError: t.licensedByValue.length,
        licenseNumberLocalError:
          t.licensedByValue.length ? getUserFriendlyErrorMessage(errorCodes.DUPLICATE_LICENSES) : '',
      }
    : t,
  )
  setLicenseArray(correctLicenseArray)
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function formatMoney(number, decPlaces?, decSep?, thouSep?) {
  decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces
  decSep = typeof decSep === 'undefined' ? '.' : decSep
  thouSep = typeof thouSep === 'undefined' ? '' : thouSep
  const sign = number < 0 ? '-' : ''
  const i = String(parseInt((number = Math.abs(Number(number) || 0).toFixed(decPlaces))))
  // @ts-expect-error TS7022 -- MIGRATION: not approved, fix when encountered
  var j = (j = i.length) > 3 ? j % 3 : 0

  return (
    sign +
    (j ? i.substr(0, j) + thouSep : '') +
    i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, '$1' + thouSep) +
    (decPlaces ?
      decSep +
      // @ts-expect-error TS2363 -- MIGRATION: not approved, fix when encountered
      Math.abs(number - i)
        .toFixed(decPlaces)
        .slice(2)
    : '')
  )
}

export const convertMoneyToUSAFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const toFindDuplicates = (array) => array.filter((item, index) => array.indexOf(item) !== index)

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const isActiveEllipsisCheck = (id, stateChangeCallBack) => {
  if (isEllipsisActive(document.getElementById(id))) {
    stateChangeCallBack(true)
  } else {
    stateChangeCallBack(false)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function imageSize(url) {
  const img = document.createElement('img')

  const promise = new Promise((resolve) => {
    img.onload = () => {
      const width = img.naturalWidth
      const height = img.naturalHeight
      // Resolve promise with the width and height
      resolve({ width, height })
    }
  })

  // Setting the source makes it start downloading and eventually call `onload`
  img.src = url

  return promise
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getAge = (dateString) => moment().diff(dateString, 'years')

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getAddressStringFromAddressObject = (addressObject) => {
  if (!addressObject) return ''
  const { City, CountryCode, StateCode, StreetAddress1, StreetAddress2, Zip } = addressObject
  return `${StreetAddress1}, ${StreetAddress2 ? StreetAddress2 + ', ' : ''}${City}, ${StateCode} ${Zip}, ${CountryCode}`
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPharmacyAddressStringFromPharmacyObject = (pharmacyObject) => {
  const { Name } = pharmacyObject || {}
  const { StreetAddress1, StreetAddress2, City, StateCode, Zip, CountryCode } = pharmacyObject?.Address || {}
  return `${Name + ' - '}${StreetAddress1 + ', '}${StreetAddress2 ? StreetAddress2 + ', ' : ''}${
    City + ', '
  }${StateCode + ' '}${Zip + ', '}${CountryCode}`
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function checkIsSameDay(from, to) {
  return from.date() === to.date() && from.month() === to.month() && from.year() === to.year()
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function toTimeZone(time, customTimeZone) {
  return moment(time || new Date())?.tz(customTimeZone)
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function FormatDate(date, dateformatType, customTimeZone) {
  switch (dateformatType) {
    case DATE_FORMAT_TYPE_DATE:
      return toTimeZone(date, customTimeZone).format('dddd MMM DD YYYY')
    case DATE_FORMAT_TYPE_TIME:
      return toTimeZone(date, customTimeZone).format('h:mma')
    default:
      break
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function isEmpty(obj) {
  return Object.keys(obj)?.length === 0
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function convertStatusToCorrectUiFormat(status) {
  if (status) {
    switch (status) {
      case STATUS_PENDING_TEXT:
        return STATUS_VALUES_MAP.get(STATUS_PENDING_TEXT)
      case STATUS_XMIT_TEXT:
        return STATUS_VALUES_MAP.get(STATUS_XMIT_TEXT)
      case STATUS_XMIT_FAILED_TEXT:
        return STATUS_VALUES_MAP.get(STATUS_XMIT_FAILED_TEXT)
      case STATUS_PRINTED_TEXT:
        return STATUS_VALUES_MAP.get(STATUS_PRINTED_TEXT)
      case STATUS_CANCELED_TEXT:
        return STATUS_VALUES_MAP.get(STATUS_CANCELED_TEXT)
      case STATUS_CANCEL_PENDING_TEXT:
        return STATUS_VALUES_MAP.get(STATUS_CANCEL_PENDING_TEXT)
      case STATUS_CANCEL_DENIED_TEXT:
        return STATUS_VALUES_MAP.get(STATUS_CANCEL_DENIED_TEXT)
      default:
        return `${status[0]}${status.split('_').join(' ').toLowerCase().slice(1)}`
    }
  }
}

export const visitLengthDropdownOption = () => {
  const min = 5
  const max = 60
  const finalArr = []
  for (let i = min; i <= max; ) {
    finalArr.unshift(i)
    i += i < 15 ? 1 : 5
  }
  return finalArr.reverse()
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getVisitLength = (number) => {
  if (Number(number) < 60) {
    return number < 10 ? `00:0${number}` : `00:${number}`
  }
  if (Number(number) === 60) {
    return '01:00'
  }
  return number === 65 ? `01:0${number - 60}` : `01:${number - 60}`
}

// @ts-expect-error TS2525 -- MIGRATION: not approved, fix when encountered
export const getFullName = ({ Prefix, FirstName, LastName, Suffix } = {}) => {
  let author = ''
  author += Prefix ? `${Prefix} ` : ''
  author += FirstName ? `${FirstName} ` : ''
  author += LastName ? `${LastName} ` : ''
  author += Suffix ? `${Suffix} ` : ''

  return author
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const isObject = (value) => Object.prototype.toString.call(value) === '[object Object]'

export const setTabId = () => {
  const newTabId = Date.now().toString()
  sessionStorage.setItem('tabId', newTabId)
}

export const getTabId = () => sessionStorage.getItem('tabId')

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getTimeZones = (allTimezones) => ({
  IDLW: 'International Date Line West',
  'America/Adak': 'Hawaii',
  'America/Guatemala': 'Central America',
  'Pacific/Marquesas': 'Hawaii',
  'Pacific/Kiritimati': "Nuku'alofa",
  ...allTimezones,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const normalizeDataByField = (data, fieldName) => {
  if (data && fieldName) {
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    return data.reduce((acc, dataItem) => {
      acc[dataItem[fieldName]] = dataItem
      return acc
    }, {})
  }
  return {}
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const parseUserDateTime = (dateTime, timeZone, withTime = true) =>
  moment(dateTime)
    .parseZone()
    .tz(timeZone, false)
    .format(`MMM DD YYYY${withTime ? ', h:mma' : ''}`)

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const parseTimeZone = (zone) => (zone ? findIana(zone)[0] : Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone)

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
function getStateAbbreviation(fullName) {
  const lastIndex = fullName.lastIndexOf(' ')
  return fullName.substring(lastIndex + 1)
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const generateStatesAbbrArrayFromStateFullNamesArray = (stateFullNamesArray) =>
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  stateFullNamesArray ? stateFullNamesArray.map((option) => getStateAbbreviation(option)) : []
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getDisplayDate = (date) => (isString(date) ? date.substring(0, 10) : date)

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const isObjectDeeplyEqual = (obj1, obj2) => {
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return obj1 === obj2
  }

  const keys1 = Object.keys(obj1)
  const keys2 = Object.keys(obj2)

  if (keys1.length !== keys2.length) {
    return false
  }

  for (let i = 0; i < keys1.length; i++) {
    const key = keys1[i]
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    if (!Object.prototype.hasOwnProperty.call(obj2, key) || !isObjectDeeplyEqual(obj1[key], obj2[key])) {
      return false
    }
  }

  return true
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const hasOwnProperty = (obj, property) => Object.prototype.hasOwnProperty.call(obj || {}, property)

/**
 * Returns an array of days of the week based on the given array of day abbreviations.
 * @param {string[]} abbrArray - An array of day abbreviations.
 * @returns {string[]} An array of days of the week.
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getDaysOfWeekFromAbbreviationArr = (abbrArray) =>
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  abbrArray?.map((abbr) => ABBREVIATION_TO_DAY_OF_WEEK[abbr])

/**
 * Capitalizes the first letter of a string
 * @param {string} string - the string to capitalize
 * @returns {string} the capitalized string
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1)

/**
 * return time zone abbreviation accordingly user systems setup
 * @returns {string} abbreviation of time zone
 */
export const getDefaultTimeZoneAbbreviation = () =>
  Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone === 'UTC' ?
    'Etc/GMT'
  : Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getAuthorName = (authorData, hasUserType = true) => {
  let author

  if (authorData) {
    const { Prefix, FirstName, LastName, Suffix, UserType } = authorData

    author = Prefix ? `${Prefix} ` : ''
    author += FirstName ? `${FirstName} ` : ''
    author += LastName ? `${LastName} ` : ''
    author += Suffix ? `${Suffix} ` : ''
    if (hasUserType) {
      author += UserType ? `(${capitalize(UserType)})` : ''
    }
  } else {
    author = 'System generated'
  }

  return author
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function isDrugScreenTagClickable(status, isMergedAccount = false) {
  return !isMergedAccount && status !== DRUG_SCREEN_STATUS.due && status !== DRUG_SCREEN_STATUS.exempt
}

/**
 * Filters an array of objects to ensure that each object has a unique value for a specified field.
 *
 * @param {Object[]} array - The array of objects to filter.
 * @param {string} field - The name of the field to check for uniqueness.
 * @returns {Object[]} A new array with objects that have unique values for the specified field.
 *
 * @example
 * const data = [
 *   { id: 1, name: 'Alice' },
 *   { id: 2, name: 'Bob' },
 *   { id: 1, name: 'Charlie' },
 *   { id: 3, name: 'David' },
 * ];
 *
 * const uniqueById = uniqueByField(data, 'id');
 * // Result: [
 * //   { id: 1, name: 'Alice' },
 * //   { id: 2, name: 'Bob' },
 * //   { id: 3, name: 'David' }
 * // ]
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function uniqueByField(array, field) {
  const seen = new Set()
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  return array.filter((obj) => {
    if (!seen.has(obj[field])) {
      seen.add(obj[field])
      return true
    }
    return false
  })
}
/**
 *
 * @param {string} stateCode The state rules to return
 * @param {*} settingsPerState List of state settings.
 * @returns
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getStateRules(stateCode, settingsPerState) {
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const stateRules = settingsPerState?.find((stateSetting) => stateSetting.StateCode === stateCode)

  return stateRules?.DrugScreenHtml || getFreeDrugRuleLayout(getStateByAbbreviation(stateCode))
}
